import React, { Component } from 'react';
import styled from 'styled-components';
import LuciPropTypes from '../../propTypes/';
import { cleanImageUrl } from '../../util/urlUtils';
import localize from '../../util/localizeUtils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ReplaceableImage = styled.img`
  min-width: 8rem;
  max-width: 8rem;
  background-color: #c2c1c1;
  transition: box-shadow 200ms ease-out;
`;

class SelectedContentSidebar extends Component {
  getUrl = () => {
    const { contentItem } = this.props;
    return cleanImageUrl(
      !contentItem.smallThumbnailUrl ? contentItem.thumbnailUrl : contentItem.smallThumbnailUrl
    );
  };
  render() {
    return (
      <Container>
        {/* eslint-disable */}
        <label>{localize('selectedContentLabel')}</label>
        {/* eslint-enable */}
        <ReplaceableImage src={this.getUrl()} />
      </Container>
    );
  }
}

SelectedContentSidebar.propTypes = {
  contentItem: LuciPropTypes.ContentItem.isRequired
};

export default SelectedContentSidebar;



// WEBPACK FOOTER //
// ./app/components/ContentSelection/SelectedContentSidebar.js